var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 120,
    viewBox: "0 0 328 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.151 36.1851L170.784 23.1102H188.856L221.963 36.0405L188.856 23.1102H170.842V5.38525H40.1794L144.685 46.201H204.151V36.1851Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1765 5.38525H2.08276L8.86611 8.36472L20.1765 12.805V5.38525Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.156 39.2441L247.968 46.201H247.983L230.156 39.2441Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9014 5.38525H20.8997V22.387H37.9014V5.38525Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6245 22.5029L72.2158 35.6212V28.0496L80.4166 31.4124V38.8249L144.251 63.7598V46.8159L38.6245 5.55176V22.5029Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.29 22.5029L221.963 35.2596V28.0496L230.156 31.4124V38.4633L294.916 63.7598V46.8159L189.29 5.55176V22.5029Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.567 5.38525H171.565V22.387H188.567V5.38525Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M327.409 46.5626V46.201H295.35L190.845 5.38522H249.574V4.66204H188.994L188.567 4.49572V4.66204H38.3281L37.9014 4.49572V4.66204H0.723171V0.952175H277.278V0.229004H0V5.38522H0.282037L20.1765 14.1211V23.1101L54.4042 36.5177V95.6225L69.4606 107.49L83.7866 118.829V48.0306L126.454 64.7504L144.916 64.801H144.967V46.9242H204.151V95.6225L219.208 107.49L233.534 118.829V47.698L277.054 64.7504L295.56 64.801L249.82 46.9242L295.133 64.6274L295.625 64.8227V46.9242H327.394L327.409 46.5626ZM219.208 106.586V36.2936L221.956 37.3856V43.4964L230.157 46.8519V40.6398L232.811 41.6884V117.296L219.208 106.586ZM204.874 36.12H218.485V106L204.874 95.2754V36.12ZM144.685 46.201L40.1794 5.38522H170.842V23.1101H188.863L221.956 36.0405L188.856 23.1101H170.777L204.151 36.1851V46.201H144.685ZM69.4751 106.571V36.2936L72.2304 37.3856V43.4964L80.4311 46.8519V40.6398L83.0779 41.6884V117.296L69.4751 106.571ZM55.1274 36.12H68.7374V106L55.1274 95.2754V36.12ZM37.9014 5.38522V22.387H20.8997V5.38522H37.9014ZM144.251 46.8157V63.7596L80.4167 38.8247V31.4122L72.2159 28.0494V35.621L38.6246 22.5027V5.55155L144.251 46.8157ZM188.567 5.38522V22.387H171.565V5.38522H188.567ZM294.917 46.8157V63.7596L230.157 38.4486V31.4122L221.956 28.0494V35.2811L189.29 22.5027V5.55155L294.917 46.8157ZM230.157 39.2803L247.983 46.2372L230.157 39.2803ZM8.86608 8.40084L2.08273 5.38522H20.162V13.3401L8.86608 8.40084Z",
    fill: "#00229A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7375 36.1191H55.1274V95.2746L68.7375 105.999V36.1191Z",
    fill: "#6071AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0635 41.6888L80.4167 40.6402V46.8522L72.216 43.4967V37.3859L69.4607 36.2939V106.572L83.0635 117.296V41.6888Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.485 36.1191H204.875V95.2746L218.485 105.999V36.1191Z",
    fill: "#6071AD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M232.811 41.6888L230.157 40.6402V46.8522L221.963 43.4967V37.3859L219.208 36.2939V106.572L232.811 117.296V41.6888Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset13);
export default __webpack_public_path__ + "static/media/Asset13.32fd8a24266265376c66fea18f02b5d7.svg";
export { ForwardRef as ReactComponent };